import * as React from 'react'
import { useConsent } from '../consent/ConsentProvider'
import { ExtensionSlot } from 'piral'

const Footer: React.FC = () => {
  const { openPreferences } = useConsent()
  return (
    <footer className='PageFooter'>
      <div className='PageFooter__slot'>
        <ExtensionSlot
          name='footer-items'
          order={exts => [...exts].sort((a, b) => (a.defaults?.order ?? 0) - (b.defaults?.order ?? 0))}
        />
      </div>
      <div className='PageFooter__notice'>
        <p className='PageFooter__label'>Propulsé par</p>
        <p>
          <a target='_blank' href='https://www.medialib.tv/' rel='noreferrer'>
                        &nbsp;<b>medialib.tv</b> - votre plate-forme vidéo en ligne par excellence
          </a>
        </p>
        <p className='PageFooter__label'>développé par</p>
        <p>
          <a target='_blank' href='https://ttree.ch' rel='noreferrer'>
            ttree.ch
          </a>
        </p>
        <p className='PageFooter__copyright'>&mdash; © {new Date().getFullYear()}</p>
        {/* GDPR: withdrawing consent must be as easy as giving it. */}
        <p>
          <button type='button' className='PageFooter__link' onClick={openPreferences}>
            Gérer les cookies
          </button>
        </p>
      </div>
    </footer>
  )
}

export default Footer
